import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

import { LoadingHero } from '@/component/LoadingHero';
import Page404 from '@/pages/Page404';
import { slugify } from '@/utils/misc';
import { ROUTE_PATH } from '@/constants/routePaths';
import { useArticleRedirectQueryRemote } from '@/store/v2';

type ArticleParams = 'id' | 'collectionId' | 'collectionName';
export const ArticleRedirect = (): JSX.Element => {
  const { id: paramsId, collectionId, collectionName } = useParams<ArticleParams>();
  const id = paramsId ? parseInt(paramsId) : 0;
  const { data, loading } = useArticleRedirectQueryRemote({ variables: { articleId: id } });

  if (loading) return <LoadingHero />;
  if (!data || !data.articleRedirect) return <Page404 />;

  const { learningId, title } = data.articleRedirect;
  const safeTitle = slugify(title);

  if (collectionId) {
    return (
      <Navigate to={`${ROUTE_PATH.COLLECTION_BASE}/${collectionId}/${collectionName}/learning/${learningId}/${safeTitle}?`} />
    );
  } else {
    return <Navigate to={`${ROUTE_PATH.LEARNING_BASE}/${learningId}/${safeTitle}`} />;
  }
};
